import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {Order} from "./order";
import {ShipmentEvent, ShipmentEventInterface} from "./shipment-event";
import {Shipment} from "./shipment";
import {User} from "@hassel-it/angular-common";

export class Package {

    static _JSONProps: string[] = [
        'id',
        'shipment_id',
        'external_reference',
        'package_info',
        'tracking_link',
        'tracking_links',
        'tracking_number',
        'tracking_number_extra',
        'number_kolli',
        'package_type',
        'created',
        'modified',
        'deleted',
        'user',
        'user_id',
        'weight',
        'carrier_code',
        'price',
        'is_printed'
    ];

    id: string;
    shipment_id: string;
    external_reference: string;
    shipment_events: ShipmentEvent[];
    package_info: string;
    package_type: string;
    tracking_link: string;
    tracking_links?: { link: string, label: string }[];
    tracking_number: string;
    tracking_number_extra: string;
    number_kolli?: number;
    created: Moment;
    modified: Moment;
    deleted?: Moment;
    user: User;
    shipment?: Shipment;
    price?: number;
    invoice_number?: string;
    weight?: number;
    carrier_code?: string;
    is_printed?: boolean;

    constructor(initializer?: PackageInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: PackageInterface | string): Package {
        if (json === null) {
            return new Package();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, Package.reviver);
        } else {
            let shipmentPackage = Object.create(Package.prototype);

            let extra = {
                user: null,
                modified: moment(json.modified),
                created: moment(json.created),
                deleted: json.deleted ? moment(json.deleted) : null,
                shipment_events: [],
                shipment: null
            };

            Object.keys(json).forEach((key, index) => {
                if (Package._JSONProps.indexOf(key) !== -1) {
                    shipmentPackage[key] = json[key];
                }

                if (key === 'shipment_events') {
                    json[key].forEach((value: ShipmentEventInterface, index) => {
                        extra.shipment_events.push(ShipmentEvent.fromJSON(value));
                    });
                }

                if (key === 'shipment' && json[key] !== null && json[key] !== undefined) {
                    extra.shipment = Shipment.fromJSON(json[key]);
                }
                if (key === 'user') {
                    extra.user = User.fromJSON(json[key]);
                    if (extra.user) {
                        const userBranch = extra.user.custom_fields.filter(field => field.key === 'branch').map((field) => {
                            return field.value;
                        }).find(Boolean)
                        extra.user.branch = userBranch;
                    }
                }
            });

            return Object.assign(shipmentPackage, extra);
        }
    }


    getDescription() {

        try {
            const json = JSON.parse(this.package_info);
            if (json.hasOwnProperty('description')) {
                return json['description'];
            }
        } catch (e) {
            return null;
        }


        return null;

    }

    getProducts(shipment: Shipment) {

        const products = [];

        try {


            const json = JSON.parse(this.package_info);


            if (json.hasOwnProperty('products')) {
                for (const productNumber of Object.keys(json['products'])) {
                    const shipmentProductLine = shipment.shipment_product_lines.find((shipmentProductLineItem) => {
                        return shipmentProductLineItem.product_number === +productNumber;
                    });

                    products.push({
                        number: productNumber,
                        shipmentProductLine: shipmentProductLine,
                        amount: json['products'][productNumber]
                    });
                }
            }
        } catch (e) {

        }
        return products;
    }

    static reviver(key: string, value: any): any {
        return key === "" ? Package.fromJSON(value) : value;
    }

    public formattedDate(field: string, format: string) {
        if (this[field]) {
            let thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface PackageInterface extends Package {

}
